import styled from 'styled-components';

const PopupButton = styled.div<{ color: string }>`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  color: #FFF;
  text-align: center;
  line-height: 76px;
  background: ${({ color }) => color};
  border-radius: 60px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.24);
  z-index: 1100;
  cursor: pointer;
  align-items: center;
  justify-content: center;
`;

export default PopupButton;
